import { type FC } from 'react';
import { Intent } from '@blueprintjs/core';
import { Button } from '@launchpad-ui/components';

import { Notifications } from '../../../../notifications/components/Notifications';

type PolicyDisplayProps = {
  title: string;
  policy: unknown;
  baseRole?: string;
  showBaseRole?: boolean;
  className?: string;
};

const copyToClipboard = (content: string) => {
  navigator.clipboard
    .writeText(content)
    .then(() => {
      Notifications.show({
        intent: Intent.SUCCESS,
        message: 'Copied to clipboard!',
      });
    })
    .catch(() => {
      const textArea = document.createElement('textarea');
      textArea.value = content;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);

      Notifications.show({
        intent: Intent.SUCCESS,
        message: 'Copied to clipboard!',
      });
    });
};

export const PolicyDisplay: FC<PolicyDisplayProps> = ({
  title,
  policy,
  baseRole,
  showBaseRole = false,
  className = '',
}) => {
  const policyJson = JSON.stringify(policy, null, 2);

  return (
    <div className={`consolidationModal__policyContainer ${className}`}>
      <div className="consolidationModal__policyHeader">
        <h4 className="consolidationModal__policyTitle">{title}</h4>
      </div>

      {showBaseRole && baseRole && (
        <div className="consolidationModal__baseRoleDisplay">
          <strong>Policy base role:</strong> {baseRole}
        </div>
      )}

      <div className="consolidationModal__policySection">
        <div className="consolidationModal__policyControls">
          <Button size="small" variant="minimal" onPress={() => copyToClipboard(policyJson)}>
            Copy
          </Button>
        </div>
        <pre className="consolidationModal__policy">{policyJson}</pre>
      </div>
    </div>
  );
};
